import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import KitchenItem from './KitchenItem';
import KitchenCartModal from './KitchenCartModal';
import { useKitchenCart } from '../context/KitchenCartContext';

const KitchenList = ({ items, searchQuery }) => {
  const [groupedItems, setGroupedItems] = useState({});
  const [filteredItems, setFilteredItems] = useState([]);
  const [showCartModal, setShowCartModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { cartItems } = useKitchenCart();
  const navigate = useNavigate();
  
  // Filter and group items when items or search query changes
  useEffect(() => {
    // Filter items based on search query
    const filtered = items.filter(item => 
      item.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
      item.category_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    
    setFilteredItems(filtered);
    
    // Group filtered items by category
    const grouped = filtered.reduce((acc, item) => {
      const category = item.category_name || 'Other';
      if (!acc[category]) {
        acc[category] = {
          items: [],
          color: item.category_color || '#666'
        };
      }
      acc[category].items.push(item);
      return acc;
    }, {});
    
    setGroupedItems(grouped);
  }, [items, searchQuery]);

  const handleItemAdded = () => {
    setShowCartModal(true);
  };

  const handleCloseCartModal = () => {
    setShowCartModal(false);
  };

  // Handle checkout - navigate to kitchen checkout page
  const handleCheckout = () => {
    if (cartItems.length === 0) return;
    
    setIsLoading(true);
    // Store cart data in sessionStorage for the checkout page
    sessionStorage.setItem('kitchenCartData', JSON.stringify(cartItems));
    setShowCartModal(false);
    setIsLoading(false);
    navigate('/kitchen/checkout');
  };

  // Render the list of items
  const renderItemsList = () => {
    if (filteredItems.length === 0) {
      return (
        <div className="no-results">
          <p>No items found matching "{searchQuery}"</p>
        </div>
      );
    }
    
    if (searchQuery.length > 0) {
      // Show ungrouped view when searching
      return (
        <div className="snacks-grid">
          {filteredItems.map(item => (
            <KitchenItem key={item.uuid} item={item} onItemAdded={handleItemAdded} />
          ))}
        </div>
      );
    } else {
      // Show grouped view by category
      return Object.entries(groupedItems).map(([category, data]) => {
        if (data.items.length === 0) return null;
        
        return (
          <div key={category} className="category-section">
            <h2 className="category-title" style={{ borderLeftColor: data.color }}>
              {category}
            </h2>
            <div className="snacks-grid">
              {data.items.map(item => (
                <KitchenItem key={item.uuid} item={item} onItemAdded={handleItemAdded} />
              ))}
            </div>
          </div>
        );
      });
    }
  };

  return (
    <div className="snacks-container">      
      {renderItemsList()}
      
      <KitchenCartModal 
        isOpen={showCartModal} 
        onClose={handleCloseCartModal}
        onCheckout={handleCheckout}
        isLoading={isLoading}
      />
    </div>
  );
};

export default KitchenList;
